import * as LucideIcons from "lucide-react";
import type { FormConfigType } from "@/types/dynamic-detail";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";

export type OfferedForm = { form: FormConfigType; index: number };

type FormChooserProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    forms: OfferedForm[];
    onChoose: (offered: OfferedForm) => void;
};

/**
 * Chooser shown when a list offers several creation forms (G2, `FormConfig.chooser_card`): one card
 * per form, in the order of `list_config.forms`. A form without a card shows its `create_label`.
 */
export function FormChooser({ open, onOpenChange, title, forms, onChoose }: FormChooserProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-2xl">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>Choisissez le formulaire de création.</DialogDescription>
                </DialogHeader>
                <div className="grid gap-2 py-2 sm:grid-cols-2">
                    {forms.map(offered => {
                        const card = offered.form.chooser_card;
                        const Icon = (card?.icon && (LucideIcons as unknown as Record<string, LucideIcons.LucideIcon>)[card.icon]) || LucideIcons.Plus;
                        return (
                            <button
                                key={offered.index}
                                type="button"
                                onClick={() => onChoose(offered)}
                                className="flex items-start gap-3 rounded-md border border-border bg-white p-3 text-left hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                            >
                                <Icon className="mt-0.5 h-4 w-4 flex-shrink-0 text-gray-600" />
                                <span className="min-w-0 space-y-1">
                                    <span className="block text-sm font-medium text-black">{card?.title ?? offered.form.create_label}</span>
                                    {card?.description && <span className="block text-xs text-gray-500">{card.description}</span>}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </DialogContent>
        </Dialog>
    );
}
